<template>
    <div class="tree_list">
        <Card title="我的目录" icon="ios-options" :padding="0" shadow style="border;">

        </Card>
        <Tree :data="tree_list" @on-select-change="tree_click"></Tree>
    </div>
</template>
<style>
    .tree_list{height:100%}
</style>
<script>
    export default {
        props:{
            tree_list:Array,
            tree_click:Function,
        },
        methods:{
        },
        data () {
            return {
                data1: [
                    {
                        title: 'parent 1',
                        expand: true,
                        children: [
                            {
                                title: 'parent 1-1',
                                expand: true,
                                children: [
                                    {
                                        title: 'leaf 1-1-1'
                                    },
                                    {
                                        title: 'leaf 1-1-2'
                                    }
                                ]
                            },
                            {
                                title: 'parent 1-2',
                                expand: true,
                                children: [
                                    {
                                        title: 'leaf 1-2-1'
                                    },
                                    {
                                        title: 'leaf 1-2-1'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>
